import { Component, Input, OnInit } from '@angular/core';
import { CustomEvents } from '@app/_helpers/constants';
import { EventsService } from '@app/_shared';
import { CUSTOM_TOASTR_TYPE } from '@app/_shared/shared.enums';
import { ToastrService } from 'ngx-toastr';
import { FixWithAiEvent, FixWithAiToastr } from '../chat.interface';

@Component({
  selector: 'app-fix-with-ai-toast',
  templateUrl: './fix-with-ai-toast.component.html',
  styleUrls: ['./fix-with-ai-toast.component.scss']
})
export class FixWithAiToastComponent implements OnInit {
  @Input('toastData') toastData: FixWithAiToastr;
  toastrTypes = CUSTOM_TOASTR_TYPE;

  constructor(
    private toastService: ToastrService,
    private eventService: EventsService,
  ) { }

  ngOnInit(): void {
  }

  closeIcon() {
    this.toastService.remove(this.toastData.toastId);
  }

  sendFixEvent() {
    const event: FixWithAiEvent = {
      threadId: this.toastData.threadId,
      message: this.toastData.message,
      ymlData: this.toastData.ymlData,
      portfolioId: this.toastData.portfolioId,
      validationErrors: this.toastData.validationErrors,
    };
    this.eventService.publish(CustomEvents.FixWithAi, event);
    this.closeIcon();
  }
}
